<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed, ref } from "vue";
import { useStore } from "@/stores";

const props = defineProps<{
  modelValue?: string;
}>();

const showPreview = ref(false);
const imageIndex = ref(0);
const { uploadDirectory } = useStore();

const fileList = computed<string[]>(() => {
  if (!props.modelValue) return [];
  return props.modelValue
    .split(",")
    .map((image) => `${uploadDirectory}/${image}`);
});

const previewList = computed(() =>
  fileList.value.map((file) => ({ src: file }))
);

function onClickItem(inx: number) {
  imageIndex.value = inx;
  showPreview.value = true;
}
</script>
<template>
  <div class="mp-uploaded-image-multi">
    <nut-image
      class="mp-uploaded-image-multi__image"
      v-bind="$attrs"
      v-for="(file, index) in fileList"
      :src="file"
      @click="onClickItem(index)"
    />
    <nut-image-preview
      :show="showPreview"
      :images="previewList"
      :init-no="imageIndex"
      :autoplay="0"
      @close="showPreview = false"
    />
  </div>
</template>
<style lang="scss">
.mp-uploaded-image-multi {
  display: inline-flex;
  flex-wrap: wrap;

  &__image {
    margin: 0 5px 5px 0;
  }
}
</style>
